import { useCallback, useState } from 'react';

// The preview's own dark/light appearance, remembered per browser (build plan
// §5.7). Storage can be missing or throw (private windows, blocked site
// data), so every read and write is guarded and the preview falls back to
// dark.
export const PREVIEW_THEME_KEY = 'pp_preview_theme';
const THEMES = ['dark', 'light'];
const DEFAULT_THEME = 'dark';

export const readPreviewTheme = () => {
  try {
    const stored = window.localStorage.getItem(PREVIEW_THEME_KEY);
    return THEMES.includes(stored) ? stored : DEFAULT_THEME;
  } catch (e) {
    return DEFAULT_THEME;
  }
};

const writePreviewTheme = (theme) => {
  try {
    window.localStorage.setItem(PREVIEW_THEME_KEY, theme);
  } catch (e) {
    // Not remembered this time; the choice still applies until reload.
  }
};

const usePreviewTheme = () => {
  const [theme, setThemeState] = useState(readPreviewTheme);

  const setTheme = useCallback((next) => {
    const value = THEMES.includes(next) ? next : DEFAULT_THEME;
    setThemeState(value);
    writePreviewTheme(value);
  }, []);

  const toggleTheme = useCallback(
    () => setTheme(theme === 'light' ? 'dark' : 'light'),
    [theme, setTheme]
  );

  return { theme, isLight: theme === 'light', setTheme, toggleTheme };
};

export default usePreviewTheme;
